<template>
<v-container grid-list-md>
    <v-row justify="center">

        <v-dialog v-model="dialogubicacion" persistent max-width="500">
            <v-card>
                <v-card-title class="modal-titulo">
                    Información
                </v-card-title>

                <v-card-text class="modal-normal">
                    Para seleccionar tu ubicacion da click en un punto dentro del mapa.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
               
                     <v-btn class="modal-btn-aceptar" text @click="aceptar">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</v-container>
</template>

<script>

import {
    mapGetters,
    mapMutations
} from "vuex";

export default {
    name: 'infoUbicacion',
    components: {

    },
    data() {
        return {
            model: 0,
            bandera:false,
        }
    },
    computed: {
        ...mapGetters(["dialogubicacion"]),
        ...mapGetters(['banderaUbicacionUsuario']),
    },
    methods: {

        aceptar(){
        this.setdialogubicacion(false);
        this.setbanderaUbicacionUsuario(true)
        },

        ...mapMutations(['setdialogubicacion']),
        ...mapMutations(['setbanderaUbicacionUsuario']),

    },
    created() {
       
    }
}
</script>

<style>
@font-face {
    font-family: 'BgFont';
    src: url('../assets/fonts/NunitoSans-Regular.ttf') format('truetype');
}

.modal-titulo {
    font-family: BgFont !important;
    font-style: normal;
    font-weight: bold !important;
    font-size: 21px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.modal-normal {
    font-family: BgFont !important;
    font-style: normal;
    font-weight: normal ;
    font-size: 16px;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.modal-btn-aceptar {
    font-family: BgFont !important;
    font-size: 16px !important;
    color: #bc157c !important;
    caret-color: #bc157c !important;
}

.v-image__image {
    z-index: -1 !important;
    width: 100% !important;
    height: 350px !important;
    background-size: contain !important;
}
</style>